<template>
	<v-container>
		<v-alert v-if="alertCriticas() && editar" color="error" :value="true" class="mb-3 mt-0">
			Instruções
			<ul>
				<li class="mb-1 mt-3">
					{{ critica }}
				</li>
			</ul>
		</v-alert>
		<v-card class="elevation-1">
			<v-toolbar flat dark color="primary">
				<v-toolbar-title>Cômodos</v-toolbar-title>
				<v-spacer />
				<v-btn
					v-if="$vuetify.breakpoint.mdAndUp"
					:disabled="!editar"
					@click.prevent="modalOpen = true; $refs.dialogAddComodo.open()"
				>
					Adicionar cômodo
				</v-btn>
			</v-toolbar>

			<v-list two-line class="py-0">
				<template v-if="comodos.length === 0">
					<v-list-tile>
						<v-list-tile-content class="pl-2">Nenhum cômodo cadastrado</v-list-tile-content>
					</v-list-tile>
				</template>
				<template v-for="(c, index) in comodos">
					<v-list-tile :key="index" avatar @click.prevent="showEditComodoDialog(index)">
						<v-list-tile-avatar class="pl-1">
							<v-icon v-if="c.residenciaComodo.id === 1" :color="alertCriticas() && editar ? 'error' : 'primary' " large>kitchen</v-icon>
							<v-icon v-if="c.residenciaComodo.id === 2" :color="alertCriticas() && editar ? 'error' : 'primary' " large>hotel</v-icon>
							<v-icon v-if="c.residenciaComodo.id === 3" :color="alertCriticas() && editar ? 'error' : 'primary' " large>weekend</v-icon>
							<v-icon v-if="c.residenciaComodo.id === 4" :color="alertCriticas() && editar ? 'error' : 'primary' " large>wc</v-icon>
							<v-icon v-if="c.residenciaComodo.id === 5" :color="alertCriticas() && editar ? 'error' : 'primary' " large>view_compact</v-icon>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title>{{ c.residenciaComodo.descricao }}</v-list-tile-title>
						</v-list-tile-content>
						<v-btn v-if="alertCriticas() && editar" icon round dark color="error">
							<v-icon v-if="editar">edit</v-icon>
							<v-icon v-else>visibility</v-icon>
						</v-btn>
						<v-btn v-else icon round dark :color="editar ? 'primary' : '#ddd'">
							<v-icon v-if="editar">edit</v-icon>
							<v-icon v-else>visibility</v-icon>
						</v-btn>
					</v-list-tile>
					<v-divider :key="`divider${index}`" />
				</template>
			</v-list>
		</v-card>

		<v-dialog-factory ref="dialogAddComodo">
			<v-comodo v-if="modalOpen" @close="close(); modalOpen = false" />
		</v-dialog-factory>

		<v-dialog-factory v-for="(c, index) in comodos" :key="index" :ref="`dialogEditComodo${index}`">
			<v-comodo :comodo="c" @close="close(index); modalOpen = false" />
		</v-dialog-factory>

		<v-btn
			v-show="$vuetify.breakpoint.smAndDown"
			:disabled="!editar"
			dark
			fab
			fixed
			bottom
			right
			color="pink"
			class="b-10"
			@click.prevent="modalOpen = true; $refs.dialogAddComodo.open()"
		>
			<v-icon>add</v-icon>
		</v-btn>

		<v-loading :show="loading" message="Processando requisição" />
	</v-container>
</template>

<script>
	import VDialogFactory from '@/components/dialogFactory';
	import VLoading from '@/components/loading';
	import VComodo from './comodo';
	import api from '@/services/api';

	export default {
		components: { VDialogFactory, VComodo, VLoading },

		data() {
			return {
				comodos: [],
				loading: false,
				editar: null,
				criticas: [],
				critica: null,
				modalOpen: false,
				pendente: false,
				reprovado: false
			};
		},

		async created() {
			this.atualizarLista();

			let editar = await api.fetchStatus();

			this.reprovado = editar.data.situacaoInscricao.descricao == 'Reprovada';

			this.pendente = editar.data.situacaoInscricao.descricao == 'Pendente';

			this.criticas = editar.data.criticas;

			this.editar = editar.data.operacoes.editar;
		},

		methods: {
			showEditComodoDialog(index) {
				this.$refs[`dialogEditComodo${index}`][0].open();
			},

			async atualizarLista() {
				try {
					this.loading = true;

					this.comodos = (await api.fetchComodos()).data;
				} catch ({ data: { message } }) {
					if (message) {
						this.$store.$emit('show-message', { message, timeout: 5000, color: 'danger' });
					}
				} finally {
					this.loading = false;
				}
			},

			alertCriticas() {
				let keys = Object.keys(this.criticas);
				for (let i = 0; i < keys.length; i++) {
					if (keys[i].includes('inscricaoResidenciaComodo')) {
						let values = Object.values(this.criticas);
						this.critica = values[i];
						return true;
					}
				} return false;
			},

			close(index) {
				this.atualizarLista();

				if (index !== null && index !== undefined) {
					this.$refs[`dialogEditComodo${index}`][0].close();
				} else {
					this.$refs['dialogAddComodo'].close();
				}
			}
		}
	};
</script>